<div *ngIf="showBanner && donor" class="thankyou-contaner">
  <div class="container">
    <div class="row">
      <div class="col-4 illustration">
        <img loading="lazy" data-src="/assets/images/story/thank-you-illustration.svg" class="thank-you-illustration" alt="Thank you illustration" />
      </div>
      <div class="col-8">
        <div class="you-have-supported-text">
          {{donor?.donor_display_name.trim()}}, you have supported this Fundraiser by contributing
          <span class="currency">
            <app-currency-icon *ngIf="donor?.iso_currency" [currency]="donor?.iso_currency"></app-currency-icon> {{donor?.donated_amount_local}}
          </span>
        </div>
        <div class="share-this-fundraiser">
          Share this Fundraiser to create a larger impact
        </div>
        <div class="d-none d-sm-block">
          <ng-template [ngTemplateOutlet]="shareButtons"></ng-template>
        </div>
      </div>
      <div class="col-lg-8 col-md-8 col-sm-12 d-sm-none">
        <ng-template [ngTemplateOutlet]="shareButtons"></ng-template>
      </div>
    </div>
  </div>
</div>

<ng-template #shareButtons>
  <div class="share-buttons">
    <app-fb-share class="share-btn1 fb-share" [campaign_url]="campaingUrl" [fundraiser]="fundraiser" backgroudColor="#ffffff"
      color="#3b5998" label="Inspire others to Contribute">
    </app-fb-share>
    <app-whatsapp-share class="share-btn1 whatsapp-share d-none d-sm-block" [basicInfo]="basicInfo" [isFundraiserEnded]="false"
      backgroudColor="#ffffff" color="#128c7e" label="Share via Whatsapp">
    </app-whatsapp-share>
    <button  #menuTrigger="matMenuTrigger" *ngIf="userData" class="menu-btn menu-toggle" mat-button [matMenuTriggerFor]="menu" mat-icon-button>
      <mat-icon>
          {{menuTrigger.menuOpen ? 'clear' : 'menu'}}
        </mat-icon>
    </button>
  </div>
  <div *ngIf="status==1" class="visible">
    <mat-icon class="icon-anonymous"></mat-icon>
    <span>Your name is only visible to you</span>
  </div>
</ng-template>
<mat-menu panelClass="menu" #menu="matMenu">
  <button class="menu-item" (click)="askUpdateClickListner($event.target)" mat-menu-item>
    <app-ask-update [isDonated]="isDonated" (isAskedForUpdate)="ifAskedForUpdate($event)"></app-ask-update>
  </button>
  <button *ngIf="donations && donations.length == 1" class="menu-item" mat-menu-item (click)="updateAnonymousStatus()">
    {{status==1?'Show my name to public':'Hide my name'}}
  </button>
</mat-menu>
